import { STORAGE_KEYS } from "@/lib/storage-keys";

export function clearSensitiveSessionStorage(): void {
	if (typeof window === "undefined") {
		return;
	}

	const keysToRemove: string[] = [
		STORAGE_KEYS.DECRYPTED_BACKUP,
		// Raw { wif, id } for the selected identity — spendable key material
		STORAGE_KEYS.ACTIVE_ACCOUNT,
		STORAGE_KEYS.TEMP_PASSWORD,
		STORAGE_KEYS.OAUTH_SIGNUP_INFO,
		STORAGE_KEYS.OAUTH_LINKING,
		STORAGE_KEYS.PENDING_OAUTH_LINK,
		STORAGE_KEYS.PENDING_BACKUP,
		STORAGE_KEYS.PENDING_IMPORT_BACKUP,
	];

	for (const key of keysToRemove) {
		sessionStorage.removeItem(key);
	}
}

export function clearSensitiveLocalStorage(): void {
	if (typeof window === "undefined") {
		return;
	}

	const keysToRemove: string[] = [
		STORAGE_KEYS.ENCRYPTED_BACKUP,
		STORAGE_KEYS.PRF_ENCRYPTED_BACKUP,
		STORAGE_KEYS.PRF_CREDENTIAL_ID,
		STORAGE_KEYS.PRF_SALT,
		STORAGE_KEYS.PRF_ENCRYPTED_ACTIVE_ACCOUNT,
		STORAGE_KEYS.CURRENT_IDENTITY,
		STORAGE_KEYS.NEW_WALLET_CLOUD_BACKUP_PENDING,
	];

	for (const key of keysToRemove) {
		localStorage.removeItem(key);
	}

	for (let index = localStorage.length - 1; index >= 0; index -= 1) {
		const key = localStorage.key(index);
		if (key?.startsWith("bap-draft-profile-")) {
			localStorage.removeItem(key);
		}
	}
}
